import { render, staticRenderFns } from "./packageRates.vue?vue&type=template&id=749a96f0"
import script from "./packageRates.vue?vue&type=script&lang=js"
export * from "./packageRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports